import { render, staticRenderFns } from "./PetAndProjectEventsTabComponent.vue?vue&type=template&id=ba7a23a0&scoped=true&"
import script from "./PetAndProjectEventsTabComponent.vue?vue&type=script&lang=js&"
export * from "./PetAndProjectEventsTabComponent.vue?vue&type=script&lang=js&"
import style0 from "./PetAndProjectEventsTabComponent.vue?vue&type=style&index=0&id=ba7a23a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7a23a0",
  null
  
)

export default component.exports